import styled from 'styled-components';
import { Table as AntDesignTable } from 'antd';
import { AA_TEXT_ON_LIGHT } from '~/modules/Helper/contrast.helper';

export const Table = styled(AntDesignTable)`
  border-radius: 8px;
  overflow: hidden;

  /* Caption programático (table_02); visual já coberto pelo PageTitle */
  table > caption {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px;
  }

  .ant-table-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px;
  }

  .ant-table-footer {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    overflow: hidden;
  }

  .ant-btn:not(.ant-btn-circle):not(.ant-btn-round) {
    border-radius: 8px;
  }

  .ant-table-thead > tr > th.ant-table-column-has-sorters:hover {
    opacity: 0.9;
  }
  .ant-table-tbody > tr.ant-table-row-level-0:hover > td {
    background: unset;
    opacity: 0.9;
  }

  .ant-table-tbody > tr.ant-table-row-level-0:hover > td.ant-table-cell-fix-right,
  .ant-table-tbody
    > tr.ant-table-row-level-0:hover
    > td.ant-table-cell-fix-right-first {
    background: ${({ theme }) => theme.corFundoGrid};
    background-clip: padding-box;
    opacity: 1;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 6px 6px;
  }
  .ant-table-thead th.ant-table-column-has-sorters {
    padding: 12px 14px;
  }

  .ant-table-filter-column {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
    width: 100%;
  }

  .ant-table-filter-column > .ant-table-column-title {
    min-width: 0; /* permite o minmax(0,1fr) funcionar e não empurrar o filtro */
    display: flex;
    align-items: center;
  }

  .ant-table-column-sorters {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .ant-table-column-sorters > .ant-table-column-title {
    white-space: nowrap;
    line-height: 1.2;
  }

  .ant-table-filter-column > .ant-table-filter-trigger {
    justify-self: end;
    flex-shrink: 0;
    margin-left: -7px;
    font-size: inherit;
  }

  .ant-table-filter-column > .ant-table-filter-trigger:not(.active):hover .anticon {
    color: var(--antd-wave-shadow-color, #000000);
    opacity: 0.5;
  }

  .anticon svg {
    filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.4));
  }
  .ant-empty-img-simple-g {
    stroke: #d9d9d9;
  }
  .ant-empty-img-simple-path {
    fill: #fafafa;
  }
  .ant-empty-description,
  .ant-empty-img-simple-ellipse {
    color: ${AA_TEXT_ON_LIGHT};
  }

  .ant-table-column-sorters-with-tooltip {
    text-align: center;

    .ant-table-column-title,
    .ant-table-cell,
    .btn-chave-visao,
    .btn-link-externo {
      font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
    }
  }

  .ant-table-cell-fix-right {
    position: sticky !important;
    right: 0;
    z-index: 11;
  }

  .ant-table-cell-fix-right::after {
    display: none;
  }
`;

export const TableResize = styled.section`
  @media only screen and (max-width: 1200px) {
    .ant-table-expanded-row-fixed {
      width: auto !important;
    }

    .ant-table-placeholder td {
      padding-left: 0px !important;
    }

    .ant-table {
      background: #ffff !important;
    }

    .ant-pagination {
      overflow-wrap: break-word;
      flex-wrap: wrap;
    }

    div.dates {
      flex-wrap: wrap;
    }

    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block !important;
    }

    table {
      width: auto !important;
    }

    thead tr {
      position: absolute !important;
      top: -9999px !important;
      left: -9999px !important;
    }

    tr:first-child {
      margin-top: -2px;
    }

    tr {
      border: 1px solid #ccc !important;
      border-bottom: 2px solid #eee !important;
    }

    tr:nth-child(even) {
      background: ${({ theme }) => `${theme.corFundoGrid}`} !important;

      & td.ant-table-cell {
        background: ${({ theme }) => `${theme.corFundoGrid}`} !important;
      }

      & td.ant-table-column-sort {
        background: ${({ theme }) => `${theme.corFundoGrid}`} !important;
      }
    }

    tr:nth-child(odd) {
      background: ${({ theme }) => `${theme.corFundoGrid}70`} !important;

      & td.ant-table-cell {
        background: ${({ theme }) => `${theme.corFundoGrid}70`} !important;
      }

      & td.ant-table-column-sort {
        background: ${({ theme }) => `${theme.corFundoGrid}70`} !important;
      }
    }

    td {
      border: none !important;
      border-bottom: 1px solid #eee !important;
      min-height: 1.25em !important;
      white-space: normal !important;
      text-align: left !important;
      display: flex !important;
    }

    td:before {
      width: 45% !important;
      padding-right: 10px !important;
      font-weight: bold !important;
      color: #006b76 !important;
    }

    td:before {
      content: attr(data-title);
    }

    button.btn-chave-visao {
      padding: 0 !important;
      height: auto !important;
      flex: 1 !important;
      white-space: normal !important;
    }

    td > span {
      width: 50% !important;
    }
  }

  @media only screen and (max-width: 820px) and (min-width: 700px) {
    ul.ant-pagination {
      justify-content: center !important;
      width: 100%;
      margin-bottom: 0.25rem;
    }

    ul.ant-pagination > li.ant-pagination-total-text {
      white-space: nowrap !important;
      white-space: nowrap !important;
      display: block;
      margin: 0;
      height: auto;
      width: 100%;
    }
  }

  @media only screen and (max-width: 580px) and (min-width: 440px) {
    ul.ant-pagination {
      justify-content: center !important;
    }

    ul.ant-pagination > li.ant-pagination-total-text {
      white-space: nowrap !important;
      display: block;
      margin: 0;
      height: auto;
      width: 100%;
    }
  }

  @media only screen and (max-width: 440px) {
    .ant-table-footer > div:first-child {
      display: contents !important;
    }

    ul.ant-pagination {
      display: block;
    }

    ul.ant-pagination > li.ant-pagination-total-text {
      display: block;
      margin: 0;
      height: auto;
      width: 100%;
    }

    ul.ant-pagination > li.ant-pagination-item {
      min-width: 29px;
    }

    button {
      margin: 0 !important;
    }
  }
`;
